/**
 * Mega Navigation - Mobile Interactions
 * Handles mobile dropdown expand/collapse within the drawer
 * Note: Drawer toggle is handled by theme.dev.js Drawer class
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const dropdownToggles = document.querySelectorAll('[js-dropdown-toggle-mobile]');
    const navDrawer = document.querySelector('#nav-drawer');

    // When drawer opens: show first-level only (Shop, Learn, etc.); second-level stays closed
    if (navDrawer) {
      const openFirstLevelOnly = function() {
        if (navDrawer.classList.contains('is-open')) {
          navDrawer.querySelectorAll('[data-meganav-first-level]').forEach(dropdown => {
            dropdown.style.display = 'block';
          });
          const firstLevelToggles = navDrawer.querySelectorAll('.menu_parent_top[js-dropdown-toggle-mobile]');
          firstLevelToggles.forEach(toggle => {
            toggle.setAttribute('aria-expanded', 'true');
          });
        }
      };

      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (navDrawer.classList.contains('is-open')) {
              setTimeout(openFirstLevelOnly, 50);
            }
          }
        });
      });

      observer.observe(navDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    // Setup dropdown toggles
    dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const link = e.currentTarget;
        const listItem = link.closest('.mobile-menu__item');
        const dropdown = listItem ? listItem.querySelector('[js-dropdown]') : null;
        
        if (dropdown) {
          toggleDropdown(link, dropdown);
        }
      });
    });

    // Close all dropdowns when drawer closes
    if (navDrawer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isOpen = navDrawer.classList.contains('is-open');
            if (!isOpen) {
              // Close all dropdowns when drawer closes
              const dropdowns = navDrawer.querySelectorAll('[js-dropdown]');
              dropdowns.forEach(dropdown => {
                dropdown.style.display = 'none';
              });
              
              const toggles = navDrawer.querySelectorAll('[js-dropdown-toggle-mobile]');
              toggles.forEach(toggle => {
                toggle.setAttribute('aria-expanded', 'false');
              });
            }
          }
        });
      });

      observer.observe(navDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  function toggleDropdown(link, dropdown) {
    const isExpanded = link.getAttribute('aria-expanded') === 'true';
    const currentDisplay = dropdown.style.display;
    
    // Close all other dropdowns at the same level
    const parent = link.closest('.mobile-menu__item');
    if (parent && parent.parentElement) {
      const siblings = parent.parentElement.querySelectorAll('.mobile-menu__item');
      siblings.forEach(sibling => {
        if (sibling !== parent) {
          const siblingDropdown = sibling.querySelector('[js-dropdown]');
          const siblingLink = sibling.querySelector('[js-dropdown-toggle-mobile]');
          if (siblingDropdown) {
            siblingDropdown.style.display = 'none';
          }
          if (siblingLink) {
            siblingLink.setAttribute('aria-expanded', 'false');
          }
        }
      });
    }
    
    // Toggle current dropdown
    if (isExpanded || currentDisplay === 'block') {
      dropdown.style.display = 'none';
      link.setAttribute('aria-expanded', 'false');
    } else {
      dropdown.style.display = 'block';
      link.setAttribute('aria-expanded', 'true');
    }
  }
})();
